import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';
import { Globals } from "../../../services/globals";
import { Router } from '@angular/router';
import { PermissionService } from '../../../../services/permission.service';

@Component({
  selector: 'app-table-sandbox-recpemail-status',
  templateUrl: './table-sandbox-recpemail-status.component.html',
  styleUrls: ['./table-sandbox-recpemail-status.component.scss']
})
export class TableSandboxRecpemailStatusComponent implements OnInit, ViewCell {
  dispResend = false;
  renderValue: boolean;
  deleteIcon = '';
  showDeleteAction: boolean;

  @Input() value: string | number;
  @Input() rowData: any;

  @Output() resendClick: EventEmitter<any> = new EventEmitter();
  @Output() deleteClick: EventEmitter<any> = new EventEmitter();
  @Output() toggleEmailPopup: EventEmitter<any> = new EventEmitter();

  constructor(
    private globals: Globals,
    private router: Router,
    private permissionService: PermissionService
  ) {
    this.deleteIcon = this.globals.getTableDeleteIcon( );
  }

  ngOnInit() {
    this.renderValue = !!this.value;
    this.dispResend = +this.rowData.status === 0 ? true : false;
    const url = this.router.url;
    const isEmailSavedScheduleReport = url.includes('analytics/saved-schedule-report');
    const isGrcsManageReports = url.includes('grcs/manage-reports');
    const isWaManageReports = url.includes('whatsapp/manage-reports');
    if (isEmailSavedScheduleReport) {
      this.showDeleteAction = this.permissionService.hasPermission('email', 'Reports', 'delete');
    } else if (isGrcsManageReports) {
      this.showDeleteAction = this.permissionService.hasPermission('rcs', 'Reports', 'delete');
    } else if (isWaManageReports) {
      this.showDeleteAction = this.permissionService.hasPermission('whatsapp', 'Reports', 'delete');
    } else {
      this.showDeleteAction = true;
    }
  }

  onResendClick() {
    this.resendClick.emit(this.rowData);
  }

  onTrashClick() {
    this.deleteClick.emit(this.rowData);
  }

  showEmailPopup() {
    this.toggleEmailPopup.emit(this.rowData);
  }
}
